import * as React from "react";
const SvgLizardSkin = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 128 128", contentScriptType: "text/ecmascript", ...props }, /* @__PURE__ */ React.createElement("path", { d: "m24.161 45.928 14.574-19.56 12.273 19.176", style: {
  fill: "none",
  stroke: "#00c000",
  strokeWidth: 3,
  strokeLinecap: "butt",
  strokeLinejoin: "miter",
  strokeMiterlimit: 4,
  strokeDasharray: "none",
  strokeOpacity: 1
}, transform: "translate(26.463)" }), /* @__PURE__ */ React.createElement("path", { d: "m24.161 45.928 14.574-19.56 12.273 19.176", style: {
  fill: "none",
  stroke: "#00c000",
  strokeWidth: 3,
  strokeLinecap: "butt",
  strokeLinejoin: "miter",
  strokeMiterlimit: 4,
  strokeDasharray: "none",
  strokeOpacity: 1
}, transform: "translate(1.887 27.908)" }), /* @__PURE__ */ React.createElement("path", { d: "m24.161 45.928 14.574-19.56 12.273 19.176", style: {
  fill: "none",
  stroke: "#00c000",
  strokeWidth: 3,
  strokeLinecap: "butt",
  strokeLinejoin: "miter",
  strokeMiterlimit: 4,
  strokeDasharray: "none",
  strokeOpacity: 1
}, transform: "translate(26.816 53.987)" }), /* @__PURE__ */ React.createElement("path", { d: "m24.161 45.928 14.574-19.56 12.273 19.176", style: {
  fill: "none",
  stroke: "#00c000",
  strokeWidth: 3,
  strokeLinecap: "butt",
  strokeLinejoin: "miter",
  strokeMiterlimit: 4,
  strokeDasharray: "none",
  strokeOpacity: 1
}, transform: "translate(52.511 24.84)" }));
export default SvgLizardSkin;
